import { tsValidate, tsValidate_OptionalArray, tsValidateArray, tsValidateOptionalId, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { clinicalForm_SelectionType_Many, clinicalForm_SelectionType_Single, clinicalForm_SubSectionType_Values, clinicalForm_SubSectionType_Variables } from './types.js';
import { knowledgeManagerDBGroup } from '../common.js';
const subSection_Validator = (instance) => {
    const type = instance?.type;
    switch (type) {
        case clinicalForm_SubSectionType_Values:
            return tsValidate(instance, subSection_Values_Validator);
        case clinicalForm_SubSectionType_Variables:
            return tsValidate(instance, subSection_Variables_Validator);
        default:
            return `No sub-section validator defined for type ${type}`;
    }
};
const subSection_Values_Validator = {
    context: tsValidateOptionalId,
    title: tsValidateString(),
    type: tsValidateValue([clinicalForm_SubSectionType_Values]),
    variableId: tsValidateUniqueId,
    valueIds: tsValidateArray(tsValidateUniqueId),
    attributes: tsValidate_OptionalArray(subSection_Validator),
    selectionType: tsValidateValue([clinicalForm_SelectionType_Many, clinicalForm_SelectionType_Single]),
};
const subSection_Variables_Validator = {
    context: tsValidateOptionalId,
    title: tsValidateString(),
    type: tsValidateValue([clinicalForm_SubSectionType_Variables]),
    variableIds: tsValidateArray(tsValidateUniqueId),
    attributes: tsValidate_OptionalArray(subSection_Validator),
    selectionType: tsValidateValue([clinicalForm_SelectionType_Many, clinicalForm_SelectionType_Single]),
};
const assessmentDialogSectionValidator = {
    title: tsValidateString(),
    subSections: tsValidateArray(subSection_Validator)
};
const Validator_ModifiableProps = {
    title: tsValidateString(),
    key: tsValidateString(),
    contextVariableId: tsValidateUniqueId,
    sections: tsValidateArray(assessmentDialogSectionValidator),
};
const Validator_GeneratedProps = {
    _valueIds: tsValidateArray(tsValidateUniqueId),
    _variableIds: tsValidateArray(tsValidateUniqueId)
};
export const DBDef_ClinicalForm = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'clinical-forms',
    entityName: 'ClinicalForm',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'clinical-form'
    },
    backend: {
        name: 'clinical-forms'
    },
    dependencies: {
        '_valueIds': {
            dbKey: 'values',
            fieldType: 'string[]'
        },
        '_variableIds': {
            dbKey: 'variables',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map